import { countries } from 'country-data';

export const AVAILABLE_COUNTRIES = countries.all
  .filter((c) => c.status === 'assigned')
  .map((c) => ({ name: c.name, alpha2: c.alpha2 }))
  .sort((a, b) => a.name.localeCompare(b.name));
